var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scrum-vision"},[_vm._m(0),_c('img',{attrs:{"src":require("@/assets/images/scrum-vision.png"),"alt":"scrum"}}),_c('Footer')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clock"},[_c('div',{staticClass:"minutes"}),_c('div',{staticClass:"hours"})])
}]

export { render, staticRenderFns }